import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import Container from './container'

const servicosData = [
    {
        icon: "../assets/servicos/ERP_icon.png",
        iconHover: "../assets/servicos/ERP_icon.png",
        title: "ERP Excellence Center",
        text: (
            <>
                Inspirada no modelo agnóstico,{" "}
                <strong className="font-bold">
                    oferecemos um novo padrão de suporte para SAP, TOTVS e
                    SENIOR
                </strong>{" "}
                - com menos burocracia, mais inteligência e total compromisso
                com o resultado do cliente.
            </>
        ),
        glowColor: "#4B3BDB",
        url: "/erp",
    },
    {
        icon: "../assets/servicos/development_icon.png",
        iconHover: "../assets/servicos/development_icon.png",
        title: "Development",
        text: (
            <>
                Alavancamos negócios focados na eficiência de aplicativos,{" "}
                <strong className="font-bold">
                    sistemas e plataformas que geram resultados efetivos
                </strong>{" "}
                e impactantes.
            </>
        ),
        glowColor: "#A002CB",
        url: "/development",
    },
    {
        icon: "../assets/servicos/ia_icon.png",
        iconHover: "../assets/servicos/ia_icon.png",
        title: "Intelligence",
        text: (
            <>
                Nossa abordagem em{" "}
                <strong className="font-bold">
                    Inteligência Artificial (IA)
                </strong>{" "}
                e <strong className="font-bold">Machine Learning (ML)</strong>{" "}
                foca em soluções <strong className="font-bold">seguras</strong>,
                eficientes e orientadas a{" "}
                <strong className="font-bold">resultados de impacto</strong>{" "}
                para nossos clientes.
            </>
        ),
        glowColor: "#FC0021",
        url: "/ia",
    },
    {
        icon: "../assets/servicos/consulting_icon.png",
        iconHover: "../assets/servicos/consulting_icon.png",
        title: "Consulting",
        text: (
            <>
                Entregamos o que seu ERP precisa de verdade:{" "}
                <strong className="font-bold">
                    estratégia, eficiência e corte de custos,
                </strong>{" "}
                com{" "}
                <strong className="font-bold">
                    suporte que resolve o que ninguém mais resolve.
                </strong>
            </>
        ),
        glowColor: "#4B3BDB",
        url: "/omnifactory",
    },
    {
        icon: "../assets/servicos/business_icon.png",
        iconHover: "../assets/servicos/business_icon.png",
        title: "Business Agility",
        text: (
            <>
                Lideramos a implementação de{" "}
                <strong className="font-bold">
                    metodologias e soluções ágeis personalizadas
                </strong>
                , criadas para superar as expectativas específicas de cada
                projeto.
            </>
        ),
        glowColor: "#A002CB",
        url: "/business-agility",
    },
    {
        icon: "../assets/servicos/cloud_icon.png",
        iconHover: "../assets/servicos/cloud_icon.png",
        title: "Cloud",
        text: (
            <>
                Apoiamos a transformação de negócios com{" "}
                <strong className="font-bold">soluções tecnológicas</strong> que
                geram eficiência e{" "}
                <strong className="font-bold">alta performance</strong>.
            </>
        ),
        glowColor: "#FC0021",
        url: "/cloud",
    },
];

export default function Servicos() {
  return (
    <div id="servicos" className="bg-[#040116] relative overflow-hidden">
      <Container className="py-14 lg:py-24">
        <div className="absolute inset-0 w-full h-full z-0 opacity-60">
          <img
            src="/assets/grafismos.svg"
            className="w-full h-full object-cover"
            alt=""
          />
          <img
            src="/assets/grafismos.svg"
            className="absolute inset-0 w-full h-full object-cover rotate-180"
            alt=""
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5 relative z-10">
          {servicosData.map((servico, index) => (
            <>
              <CardServicos
                key={index}
                {...servico}
                className="hidden md:block"
                width="full"
              />
              <AccordionServicos key={index} {...servico} />
            </>
          ))}
        </div>
      </Container>
    </div>
  )
}
